import { useLayoutEffect, type RefObject } from 'react';
import { BRAVEMOVE_MOTION, BRAVEMOVE_SPACE } from '@bravemove/design-tokens';

/** Progressive entrance only: content is visible even without the animation API. */
export function useEntranceMotion(ref: RefObject<HTMLElement | null>, active = true): void {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!active || !element?.animate || typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (media.matches) return;
    const animation = element.animate(
      [
        { opacity: 0, transform: `translateY(${BRAVEMOVE_SPACE[2]}px)` },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      { duration: BRAVEMOVE_MOTION.dur.quick, easing: BRAVEMOVE_MOTION.ease.out },
    );
    const stop = () => {
      if (media.matches) animation.cancel();
    };
    media.addEventListener('change', stop);
    return () => {
      animation.cancel();
      media.removeEventListener('change', stop);
    };
  }, [active, ref]);
}
